import React, { useState, useRef, useEffect } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import { BiUpload } from "react-icons/bi";
import { FaChevronDown } from "react-icons/fa";
import axiosConfig from "../../Service/AxiosConfig";
import { PopupModal } from "../../PopupModal/PopupModal";
import DataTable from "react-data-table-component";
import { HiArrowDownTray } from "react-icons/hi2";
import { FaTrashAlt } from "react-icons/fa";
import ShowDeleteModal from "../../Modal/ShowDeleteModal";
const Verification = ({ form, setForm, fetchBooking }) => {
  const [expanded, setExpanded] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const [saving, setSaving] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const hasFocusedOnce = useRef(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [popupType, setPopupType] = useState("");
  const aadhaarInputRef = useRef(null);
  const panInputRef = useRef(null);

  const [message, setMessage] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [errors, setErrors] = useState({
    aadhaar_number: "",
    adhaar_file: "",
    pan_number: "",
    pan_file: "",
  });
  const firstFieldRef = useRef(null);
  const fieldsToCheck = [
    "aadhaar_number",
    "adhaar_file",
    "pan_number",
    "pan_file",
  ];

  const hasAnyData = fieldsToCheck.some((key) => {
    const value = form?.[key];
    if (value instanceof File) return true;
    if (typeof value === "string") return value.trim() !== "";
    return false;
  });

  useEffect(() => {
    if (!form?.id) return;
    const initialHasData = fieldsToCheck.some((key) => {
      const value = form?.[key];
      if (value instanceof File) return true;
      if (typeof value === "string") return value.trim() !== "";
      return false;
    });

    setEditMode(!initialHasData);
  }, [form?.id]);

  useEffect(() => {
    if (!expanded || hasFocusedOnce.current) return;

    const timer = setTimeout(() => {
      if (firstFieldRef.current && editMode) {
        firstFieldRef.current.focus();
        hasFocusedOnce.current = true;
      }
    }, 150);

    return () => clearTimeout(timer);
  }, [expanded, editMode]);

  const handleChange = (name, value) => {
    setIsDirty(true);

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAadhaarChange = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 12);

    handleChange("aadhaar_number", value);

    if (value.length !== 12) {
      setErrors((prev) => ({
        ...prev,
        aadhaar_number: "Aadhaar must be exactly 12 digits",
      }));
    } else {
      setErrors((prev) => ({
        ...prev,
        aadhaar_number: "",
      }));
    }
  };
  const handlePanChange = (e) => {
    const value = e.target.value
      .toUpperCase()
      .replace(/[^A-Z0-9]/g, "")
      .slice(0, 10);

    handleChange("pan_number", value);

    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

    if (value.length === 10 && !panRegex.test(value)) {
      setErrors((prev) => ({
        ...prev,
        pan_number: "Invalid PAN format (ABCDE1234F)",
      }));
    } else {
      setErrors((prev) => ({
        ...prev,
        pan_number: "",
      }));
    }
  };

  const handleFileChange = (e, key) => {
    const file = e.target.files[0];
    const MAX_FILE_SIZE = 2 * 1024 * 1024;

    if (!file) return;

    if (form?.[key]) {
      setPopupType("error");
      setErrorMsg(
        key === "adhaar_file"
          ? "Aadhaar file already uploaded. Please delete it before uploading again."
          : "PAN file already uploaded. Please delete it before uploading again.",
      );
      return;
    }

    const validTypes = ["application/pdf", "image/jpeg", "image/png"];

    if (!validTypes.includes(file.type)) {
      setPopupType("error");
      setErrorMsg("Only PDF, JPG, PNG allowed");
      return;
    }

    if (file.size > MAX_FILE_SIZE) {
      setPopupType("error");
      setErrorMsg("Max file size is 2MB");
      return;
    }

    setIsDirty(true);

    setForm((prev) => ({
      ...prev,
      [key]: file,
    }));

    // Allow selecting the same file again after delete/retry.
    e.target.value = "";
  };

  const handleSave = async () => {
    setSaving(true);
    const isUpdate =
  !!form?.aadhaar_number ||
  !!form?.pan_number ||
  !!form?.adhaar_file ||
  !!form?.pan_file;

try {
  const payload = new FormData();
      payload.append("aadhaar_number", form.aadhaar_number || "");
      payload.append("pan_number", form.pan_number || "");

      if (form.adhaar_file instanceof File) {
        payload.append("adhaar_file", form.adhaar_file);
      }

      if (form.pan_file instanceof File) {
        payload.append("pan_file", form.pan_file);
      }

      await axiosConfig.patch(`/provider-data/providers/${form.id}/`, payload);
      setIsDirty(false);
      setExpanded(false);
      setEditMode(false);
      setPopupType("success");
setMessage(
  isUpdate
    ? "Details Updated Successfully"
    : "Details Saved Successfully"
);      fetchBooking();
    } catch (err) {
      setPopupType("error");
      setErrorMsg(
        err?.response?.data?.detail || "Failed to save personal details",
      );
    } finally {
      setSaving(false);
    }
  };
  const confirmDelete = async () => {
    try {
      await axiosConfig.delete(
        `/provider-data/providers/${form?.id}/delete-document/?type=${deleteId}`,
      );

      if (deleteId === "aadhaar") {
        setForm((prev) => ({
          ...prev,
          adhaar_file: null,
          aadhaar_verified: false,
        }));
      }

      if (deleteId === "pan") {
        setForm((prev) => ({
          ...prev,
          pan_file: null,
          pan_verified: false,
        }));
      }

      fetchBooking();
      setPopupType("success");
      setMessage("Deleted successfully");
    } catch (err) {
      setPopupType("error");
      setErrorMsg("Delete failed");
    } finally {
      setShowDeletePopup(false);
      setDeleteId(null);
    }
  };

  const columns = [
    {
      name: "S.No",
      selector: (_, index) => index + 1,
      width: "80px",
    },
    {
      name: "File Name",
      selector: (row) => row.FileName,
    },
    {
      name: "Status",
      cell: (row) => (
        <span
          style={{
            color: row.verified ? "green" : "red",
            fontWeight: 500,
          }}
        >
          {row.verified ? "Verified" : "Not Verified"}
        </span>
      ),
    },
    {
      name: "Actions",
      width: "120px",
      cell: (row) => (
        <div style={{ display: "flex", gap: 12 }}>
          <button
            aria-label="Delete document"
            disabled={!editMode}
            onClick={() => {
              if (!editMode) return;
              setDeleteId(row?.id);
              setShowDeletePopup(true);
            }}
            style={{ background: "none", border: "none", cursor: "pointer" }}
          >
            <FaTrashAlt size={14} color={editMode ? "red" : "#ccc"} />
          </button>

          {!row.isNew && (
            <a href={row.preview} target="_blank" rel="noreferrer">
              <HiArrowDownTray size={18} />
            </a>
          )}
        </div>
      ),
    },
  ];
  const data = [
    ...(form?.adhaar_file
      ? [
          {
            id: "aadhaar",
            FileName: "Aadhaar",
            preview:
              form.adhaar_file instanceof File
                ? URL.createObjectURL(form.adhaar_file)
                : form.adhaar_file,
            verified: form?.aadhaar_verified || false,
          },
        ]
      : []),

    ...(form?.pan_file
      ? [
          {
            id: "pan",
            FileName: "PAN",
            preview:
              form.pan_file instanceof File
                ? URL.createObjectURL(form.pan_file)
                : form.pan_file,
            verified: form?.pan_verified || false,
          },
        ]
      : []),
  ];

  return (
    <>
      <Accordion
        key={expanded ? "open" : "closed"}
        allowZeroExpanded
        preExpanded={expanded ? ["verification"] : []}
        onChange={(uuids) => {
          setExpanded(uuids.includes("verification"));
        }}
      >
        <AccordionItem uuid="verification">
          <AccordionItemHeading>
            <AccordionItemButton className="bd-header">
              <h4 className="bd-title">Adhaar & PAN</h4>
              <span className="bd-add-btn">
                Add Details
                <FaChevronDown
                  style={{
                    transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "0.3s",
                  }}
                />
              </span>
            </AccordionItemButton>
          </AccordionItemHeading>

          <AccordionItemPanel className="bd-panel">
            <div className="verification-section">
              <div className="form-group">
                <label
                  className={`form-label ${!editMode ? "view-mode-label" : ""}`}
                >
                  Aadhaar Number
                </label>
                <input
                  type="text"
                  ref={firstFieldRef}
                  maxLength={12}
                  placeholder="************"
                  value={form.aadhaar_number || ""}
                  disabled={!editMode}
                  onChange={handleAadhaarChange}
                  className={`form-control ${!editMode ? "view-mode-text" : ""}`}
                />

                {errors.aadhaar_number && (
                  <p className="error-text">{errors.aadhaar_number}</p>
                )}
              </div>
              <div className="form-group">
                <label
                  className={`form-label ${!editMode ? "view-mode-label" : ""}`}
                >
                  Aadhaar Image
                </label>
                <div
                  className="form-group icon-upload"
                  onClick={() => {
                    if (!editMode) return;
                    aadhaarInputRef.current?.click();
                  }}
                  style={{ cursor: editMode ? "pointer" : "not-allowed" }}
                >
                  <span
                    className={`form-label ${!editMode ? "view-mode-label" : ""}`}
                  >
                    <BiUpload size={18} style={{ marginRight: "6px" }} />
                    Upload Now
                  </span>
                  <input
                    type="file"
                    id="aadhaarUpload"
                    className={`form-control ${!editMode ? "view-mode-label" : ""}`}
                    hidden
                    ref={aadhaarInputRef}
                    disabled={!editMode}
                    onChange={(e) => handleFileChange(e, "adhaar_file")}
                  />
                </div>
                {errors.adhaar_file && (
                  <p className="error-text">{errors.adhaar_file}</p>
                )}
                {errors?.aadhaar_blur && (
                  <p className="error-text">The document photo is blurry.</p>
                )}
              </div>
              <div className="form-group">
                <label
                  className={`form-label ${!editMode ? "view-mode-label" : ""}`}
                >
                  PAN Number
                </label>
                <input
                  type="text"
                  maxLength={10}
                  placeholder="**********"
                  value={form.pan_number || ""}
                  disabled={!editMode}
                  onChange={handlePanChange}
                  className={`form-control ${!editMode ? "view-mode-text" : ""}`}
                />

                {errors.pan_number && (
                  <p className="error-text">{errors.pan_number}</p>
                )}
              </div>
              <div className="form-group">
                <label
                  className={`form-label ${!editMode ? "view-mode-label" : ""}`}
                >
                  PAN Image
                </label>

                <div
                  className="form-group icon-upload"
                  onClick={() => {
                    if (!editMode) return;
                    panInputRef.current?.click();
                  }}
                  style={{ cursor: editMode ? "pointer" : "not-allowed" }}
                >
                  <span
                    className={`form-label ${!editMode ? "view-mode-label" : ""}`}
                  >
                    <BiUpload size={18} style={{ marginRight: "6px" }} />
                    Upload Now
                  </span>
                  <input
                    type="file"
                    id="panUpload"
                    ref={panInputRef}
                    className={`form-control ${!editMode ? "view-mode-label" : ""}`}
                    hidden
                    disabled={!editMode}
                    onChange={(e) => handleFileChange(e, "pan_file")}
                  />
                </div>

                {errors.pan_file && (
                  <p className="error-text">{errors.pan_file}</p>
                )}

                {form?.pan_blur && (
                  <p className="error-text">The document photo is blurry.</p>
                )}
              </div>
              <div className="form-group verification-full">
                <DataTable
                  columns={columns}
                  data={data}
                  dense
                  highlightOnHover
                  progressPending={saving}
                  noDataComponent="No documents uploaded"
                />
              </div>
              <div className="form-group verification-full">
                <div className="bd-actions">
                  {!editMode ? (
                    <button
                      className="bd-edit-btn"
                      onClick={() => {
                        setEditMode(true);
                        setIsDirty(true);
                        setExpanded(true);
                      }}
                    >
                      Edit
                    </button>
                  ) : (
                    hasAnyData &&
                    editMode && (
                      <button
                        className="bd-save-btn"
                        onClick={handleSave}
                        disabled={saving}
                      >
                        Save
                      </button>
                    )
                  )}
                </div>
              </div>
            </div>
          </AccordionItemPanel>
        </AccordionItem>
      </Accordion>
      {showDeletePopup && (
        <ShowDeleteModal
          open={showDeletePopup}
          onConfirm={confirmDelete}
          onCancel={() => setShowDeletePopup(false)}
        />
      )}
      {popupType && (
        <PopupModal
          setpopupType={setPopupType}
          popupType={popupType}
          error={errorMsg}
          Message={message}
          setMessage={setMessage}
        />
      )}
    </>
  );
};

export default Verification;
